export default function MonsterTamerIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <ellipse cx="28" cy="58" rx="20" ry="4" fill="rgba(0,0,0,0.25)" />
      {/* crown of campfire flames behind the head */}
      <path d="M16 30q-6-10 2-18q0 6 4 8q-2-10 6-16q0 8 4 10q2-8 8-10q-2 8 2 12q4-4 8-4q-4 6-2 18z" fill="#ffcf3a" stroke="#3a2030" strokeWidth="2.5" strokeLinejoin="round" />
      {/* round bear ears */}
      <circle cx="14" cy="26" r="6" fill="#ff8a3d" stroke="#3a2030" strokeWidth="2.5" />
      <circle cx="42" cy="26" r="6" fill="#ff8a3d" stroke="#3a2030" strokeWidth="2.5" />
      <circle cx="14" cy="26" r="2.6" fill="#ffd9a0" />
      <circle cx="42" cy="26" r="2.6" fill="#ffd9a0" />
      <ellipse cx="28" cy="40" rx="19" ry="17" fill="#ff8a3d" stroke="#3a2030" strokeWidth="2.5" />
      <ellipse cx="28" cy="47" rx="11" ry="8" fill="#ffd9a0" />
      <circle cx="21" cy="36" r="4" fill="#fff" />
      <circle cx="35" cy="36" r="4" fill="#fff" />
      <circle cx="22" cy="37" r="2.4" fill="#1b1530" />
      <circle cx="36" cy="37" r="2.4" fill="#1b1530" />
      <path d="M24 43q4 4 8 0" stroke="#3a2030" strokeWidth="2" fill="none" strokeLinecap="round" />
      {/* Tame Crystal */}
      <circle cx="52" cy="48" r="11" fill="rgba(190,140,255,0.35)" />
      <path d="M52 36l6 8-1.5 9L52 61l-4.5-8L46 44z" fill="#b07cff" stroke="#3a1f6e" strokeWidth="2.2" strokeLinejoin="round" />
      <path d="M52 36l-1.5 8L52 61M46 44h12" stroke="rgba(255,255,255,0.6)" strokeWidth="1.2" fill="none" />
      <circle cx="49.5" cy="41" r="1.3" fill="#fff" />
    </svg>
  );
}
